import { TitleBlockSizes } from '@anm/components/TitleBlock';
import Button, { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import noop from '@anm/helpers/noop';
import { FC } from 'react';

import AlertBlockWrapper, { AlertTitleBlock } from './Wrapper';

export type AlertBlockButton = {
  text: string;
  size: ButtonSize;
  variant: ButtonVariants;
};

export type AlertBlockProps = {
  title?: string;
  button?: AlertBlockButton;
  maxWidth?: number;
  titleSize?: TitleBlockSizes;
  className?: string;
  description?: string;
  onButtonClick?: () => void;
  renderTopContent?(): void;
};

const AlertBlock: FC<AlertBlockProps> = ({
  title,
  children,
  className,
  maxWidth = 392,
  description,
  onButtonClick,
  renderTopContent = noop,
  button = {
    text: 'Ok',
    size: 'upper-medium',
    variant: 'blue-heavy-border'
  },
  titleSize = 'medium'
}) => {
  const { text, size, variant } = button;

  return (
    <AlertBlockWrapper {...{ maxWidth, className }}>
      {renderTopContent()}
      <AlertTitleBlock level={3} {...{ title, description }} size={titleSize} />
      {children}
      <Button {...{ size, variant }} data-button="AlertBlock modal ok" onClick={onButtonClick}>
        {text}
      </Button>
    </AlertBlockWrapper>
  );
};

export default AlertBlock;
